import React, { useCallback, useEffect, useState } from 'react'
import { paymentServices } from 'src/services/payment/Payment.service'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { useTranslate } from 'react-admin'
import { parseDateFormat } from 'src/helper/parseDateFormat';
import {Skeleton, Button} from '@mui/material'

const ExchangeCard = ({currencies_exchange}) =>{
    const translate = useTranslate()
    const [openExchange, setOpenExchange] = useState(false)
    return(
        <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
            <Button onClick={()=>{setOpenExchange(!openExchange)}}>
                {translate("ra.title.exchange_type")}
            </Button>
            {openExchange && 
                <div style={{borderWidth:'1px', marginBottom:'15px',borderColor:'black', borderStyle:'solid', display:'flex', flexDirection:'column', padding:'15px', borderRadius:'10px', width:'50%'}}>
                {currencies_exchange.map(cur=>(
                    
                    <label>
                        {`${cur.currency_relation_name} - ${cur.currency_to_relation_name}: ${numberFormatterWithDecimalAndThousand(cur.value)}`}
                    </label>
                ))}
                </div>
            }
        </div>
    )
}

export const CreditsDetail = ({account_id}) => {
    const translate = useTranslate()
    const [payments, setPayments] = useState([])
    const [isfetchingData, setIsfetchingData] = useState(false)

    const getpaymentOrigin = useCallback(() => {
        setIsfetchingData(true)
        paymentServices.getPaymentOrigin(account_id).then(res=>{
            setPayments(res)
        }).finally(()=>{
            setIsfetchingData(false)
        })
    },[account_id])

    useEffect(()=>{
        getpaymentOrigin()
    },[getpaymentOrigin])
  return (
    <div>
        {isfetchingData ? <Skeleton variant='rectangular' width={'100%'} height={20} /> :
        payments.map(payment=>(
            <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                <div style={{display:'flex', flexDirection:'row',justifyContent:'space-evenly'}}>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <label>
                            {`Id`}
                        </label>
                        <label>
                            {payment.payment_id}
                        </label>
                    </div>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <label>
                            {`${translate('ra.field.created_at')}`}
                        </label>
                        <label>
                            {parseDateFormat(payment.created_at)}
                        </label>
                    </div>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <label>
                            {`${translate('ra.field.payment_type')}`}
                        </label>
                        <label>
                            {payment.payment_type_long_name}
                        </label>
                    </div>
                    <div style={{display:'flex', flexDirection:'column'}}>
                        <label>
                            {`${translate('ra.field.amount')}`}
                        </label>
                        <label>
                            {numberFormatterWithDecimalAndThousand(payment.amount)}
                        </label>
                    </div>
                </div>
                <ExchangeCard currencies_exchange={payment.currencies_exchange}/>
            </div>
        ))}
    </div>
  )
}
